<template>
  <v-container fluid class="pa-0 ma-0">
    <v-data-table
      dense
      :headers="headers"
      :items="data"
    >
      <template v-slot:item.billRate="{ item }">
        {{ item.billRate | currency }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>

export default {
  props: [
    'data'
  ],
  data () {
    return {
      headers: [
        { text: 'Consultant', value: 'fullName', width: '70%' },
        { text: 'Hourly Bill Rate', value: 'billRate', align: 'center', width: '30%' }
      ]
    }
  }
}
</script>
